import { useFlags as launchdarklyUseFlags } from 'launchdarkly-react-client-sdk';

import { isDev } from '~/dev/utils/isDev';

import { flags } from './flags';

const applyHardcodedFlags = isDev;

export const useFlags = () =>
  applyHardcodedFlags ? flags : (launchdarklyUseFlags() ?? {});
